import { useLanguageSync } from "../hooks/useLanguageNavigation";

/**
 * Language Sync Component
 * Automatically syncs language between URL and i18n
 * Should be placed inside Router context
 */
const LanguageSync = () => {
  useLanguageSync();
  return null;
};

export default LanguageSync;

